<template>
  <div class="animated fadeIn">
    <b-modal
      ref="modal-contact"
      scrollable
      centered
      button-size="sm"
      @hidden="onHideModal"
      >
      <template #modal-title>
        <i class="fas fa-user"></i> ADICIONAR CONTATOS
      </template>
      <div class="form-group row">
        <div class="col-md-12">
            <label><small class="text-danger" v-if="form.documento.required">*</small> CPF/CNPJ:</label>
            <div class="input-group">
              <b-form-input type="text"
                            :placeholder="'Digite o CPF ou CNPJ do Contato'"
                            v-model="form.documento.value"
                            :size="form.documento.maxlength"
                            :required="form.documento.required"
                            :state="form.documento.state"
                            v-mask="['###.###.###-##', '##.###.###/####-##']"
                            ></b-form-input>
              <span class="input-group-addon" v-if="false"><i class="fa fa-search"></i></span>
            </div>
          </div>
        <div class="col-md-12">
          <label><small v-show="form.nome.required" class="text-danger">*</small> Nome:</label>
          <div class="input-group">
            <b-form-input type="text"
                          :placeholder="'Digite o Nome do contato'"
                          v-model="form.nome.value"
                          :size="form.nome.maxlength"
                          :required="form.nome.required"
                          :state="form.nome.state"></b-form-input>
          </div>
        </div>
      </div>
      <div class="form-group row pt-2">
        <div class="col-md-12">
          <label><small v-show="form.email.required" class="text-danger">*</small> E-mail:</label>
          <div class="input-group">
            <b-form-input type="text"
                          :placeholder="'Digite o E-mail do contato'"
                          v-model="form.email.value"
                          :size="form.email.maxlength"
                          :required="form.email.required"
                          :state="form.email.state"></b-form-input>
          </div>
        </div>
      </div>
      <div class="form-group row pt-2 pb-3">
        <div class="col-md-12">
          <label><small v-show="form.celular.required" class="text-danger">*</small> Celular:</label>
          <div class="input-group">
            <b-form-input type="text"
                          :placeholder="'Digite o Celular (Whatsapp) do contato'"
                          v-model="form.celular.value"
                          :size="form.celular.maxlength"
                          :required="form.celular.required"
                          :state="form.celular.state"
                          v-mask="['(##) ####-####', '(##) # ####-####']"></b-form-input>
          </div>
        </div>
      </div>
      <template #modal-footer>
        <div class="w-100 text-right">
          <button
            type="button"
            class="btn btn-third btn-sm"
            v-b-tooltip.hover
            :title="'Adicionar'"
            @click="onCreate"
          >
            <i class="fas fa-check-circle"></i>
            <span class="d-md-down-none"> Adicionar</span>
          </button>
        </div>
      </template>
    </b-modal>
  </div>
</template>
<script>
import ActionsForm from '@/shared/mixins/actionsForm'
import { toast, loading } from '@/shared/utils/UIHelper'
import Tools from '@/components/tools/Tools.js'
import ContactForm from './contact-form.js'
import _ from 'lodash'

import SegmentationContactRepository from '@/shared/http/repositories/configurations/campaignlistcontact.js'

const ContactModel = {
  campanhaListaId: null,
  documento: null,
  nome: null,
  email: null,
  celular: null
}

export default {
  name: 'ModalSegmentContactAdd',
  mixins: [ActionsForm],
  data () {
    return {
      data: _.cloneDeep(ContactModel),
      form: _.cloneDeep(ContactForm),
      campanhaListaId: null
    }
  },
  methods: {
    showModal (campanhaListaId) {
      this.campanhaListaId = campanhaListaId
      this.$refs['modal-contact'].show()
    },
    hideModal () {
      this.$refs['modal-contact'].hide()
      this.onHideModal()
    },
    onHideModal () {
      this.reset()
    },
    reset () {
      this.data = _.cloneDeep(ContactModel)
      this.form = _.cloneDeep(ContactForm)
      this.campanhaListaId = null
    },
    onCreate () {
      loading.push()

      if (Tools.ValidateForms(this.form, this.data, self, toast)) {
        this.data.campanhaListaId = this.campanhaListaId
        // this.data.celular = this.form.celular.value.replaceAll('(', '').replaceAll(')', '')
        SegmentationContactRepository.Create(this.data)
          .then((response) => {
            loading.close()
            this.hideModal()
            this.$emit('created')
            toast.success(this.$lang.Common.Alerts.Success)
          })
          .catch(this.onException)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/configurations/campaign/campaignlist/components/add/modal/contactmodal/contact.vue